module.exports = __webpack_public_path__ + "static/3.302fda7a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel/organizacja/3.jpg
// module id = 666
// module chunks = 65182145508788